mutation DispatchFetchOrder(
  $agentRegistrationId: ID!
  $fileNumber: String!
) {
  dispatchFetchOrder(
    input: {
      agentRegistrationId: $agentRegistrationId
      fileNumber: $fileNumber
    }
  ) {
    workItem {
      id
      databaseId
      status
    }
    errors
  }
}
